import { Component, ViewChildren, QueryList, AfterViewInit, OnDestroy, ElementRef, ChangeDetectionStrategy, signal, input } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';
import { AnyInnerSection, Section, SectionAttributes } from '../../types/section';
import { PlainImageComponent, PlainImageSection } from '../../../app/components/plain-image/plain-image.component';
import tippy, { Instance, Props } from 'tippy.js';
import { MediumComponent, MediumSection, isMediumSection } from '../medium/medium.component';
import { isPlatformServer } from '@angular/common';
import { TeaserCardComponent, TeaserCardSection, isTeaserCardSection } from '../../../app/components/teaser-card/teaser-card.component';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

interface InteractiveImageAttributes extends SectionAttributes {
  numColumns: 12 | 8 | 4;
  headline?: string;
  //viewBoxWidth: number;
  //viewBoxHeight: number;
  baseImage: PlainImageSection;
  buttons: {
    content: TeaserCardSection | MediumSection;
    style: 'hightlighted-circle';
    center: {
      x: number;
      y: number;
    };
  }[];
}

type InteractiveImageEditorIds = [
  'numColumns',
  'headline',
]

export type InteractiveImageSection = Section<InteractiveImageAttributes, InteractiveImageEditorIds, 'interactive-image'>;

export function isInteractiveImageSection(section: AnyInnerSection): section is InteractiveImageSection {
  return section.component === 'interactive-image';
}

@Component({
    selector: 'app-interactive-image',
    styleUrls: ['./interactive-image.component.scss'],
    templateUrl: './interactive-image.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        TeaserCardComponent,
        MediumComponent,
        PlainImageComponent,
        FsButtonComponent,
    ],
})
export class InteractiveImageComponent extends SectionComponent<InteractiveImageSection> implements AfterViewInit, OnDestroy {
  @ViewChildren('buttons') private buttons!: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('contentTemplates') private contentTemplates!: QueryList<ElementRef<HTMLTemplateElement>>;

  public appendTo = input<Props['appendTo']>('parent');

  private tooltipInstances: Instance[] = [];

  protected activeButtonIndex = signal(-1);

  public override ngAfterViewInit() {
    super.ngAfterViewInit();
    this.initTooltips();
  }

  private initTooltips(): void {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    const contentTemplateArray = this.contentTemplates.toArray();

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;

    this.buttons.forEach((button, index) => {
      const contentTemplate = contentTemplateArray[index];
      this.tooltipInstances[index] = tippy(button.nativeElement, {
        content: contentTemplate.nativeElement,
        trigger: 'click',
        zIndex: 1,
        maxWidth: 'none',
        appendTo: this.appendTo(),
        interactive: true,
        onShow() {
          self.activeButtonIndex.set(index);
        },
        onHide() {
          self.activeButtonIndex.set(-1);
        },
      });
    });
  }

  public ngOnDestroy() {
    for (const popperInstance of this.tooltipInstances) {
      popperInstance.destroy();
    }
  }

  protected isMediumSection = isMediumSection;
  protected isTeaserCardSection = isTeaserCardSection;

}
